import { fillString } from '@local_modules/generic/string-template.js'
import { AutoAgGrid, generateString, setPageAsFullHeight } from '@local_modules/flokit'
import '@local_modules/flokit/styles.css'
import { setElementHtml } from '../../../../helpers/generic-js/dom.js'

import htmlTemplateIndex from './index.html'

import { checkPageRestriction } from '../../../../helpers/restrictions/check-page-restriction.js'
import { applyHtmlRestrictions } from '../../../../helpers/restrictions/apply-html-restrictions.js'

/**
 *
 * @param {Object} params
 * @param {String} params.containerElementId
 * @param {Object} params.browserAppUser
 *
 * @returns
 */
export async function showAdminListEntitiesLedgers (params) {
  console.log('showAdminListEntitiesLedgers')

  const { containerElementId, browserAppUser } = params

  if (!checkPageRestriction({ browserAppUser, allowNoAccount: true })) return

  // Prepare the html
  let htmlIndex = htmlTemplateIndex

  htmlIndex = applyHtmlRestrictions(htmlIndex, { browserAppUser })
  const elementId = 'i' + generateString()
  htmlIndex = fillString(htmlIndex, { elementId })

  // Inject in the page
  setElementHtml(containerElementId, htmlIndex)

  setPageAsFullHeight(true, { containerSelector: '#app-content' })

  // Set page title
  document.title = ['All Entities'].join(' ')

  const autoAgGrid = new AutoAgGrid({
    containerSelector: '#entityGrid',
    sourceUrl: '/api/data-review/listing-with-duplicate-and-missing',
    gridParams: {
      columns: {
        accounting_organisation_id: {
          show: false
        },
        organisation_name: {
          cellRenderer: function (cellParams) {
            return `<a href="/app/admin/entity/${cellParams.data.accounting_organisation_id}">${cellParams.data.organisation_name}</a>`
          }
        },
        duplicate_numbers: {
          cellRenderer: function (cellParams) {
            return `<a href="/app/admin/entity/${cellParams.data.accounting_organisation_id}/journals-duplicates">${cellParams.data.duplicate_numbers}</a>`
          }
        },
        missing_numbers: {
          cellRenderer: function (cellParams) {
            return `<a href="/app/admin/entity/${cellParams.data.accounting_organisation_id}/missing-journal-numbers">${cellParams.data.missing_numbers}</a>`
          }
        }
      }
    }
  })
  console.log('autoAgGrid', autoAgGrid)
  return autoAgGrid
}
